"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsageContent = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var __1 = require("..");
var core_1 = require("../../../../shared/core");
var analytics_subjects_1 = require("../../analytics-subjects");
var copy_1 = require("../../copy");
var utils_1 = require("../../utils");
var utils_2 = require("./utils");
var UsageContent = function (_a) {
    var _b;
    var accountId = _a.accountId, data = _a.data, date = _a.date, comparisonDate = _a.comparisonDate, setDate = _a.setDate, compare = _a.compare, setCompare = _a.setCompare, datePeriod = _a.datePeriod, supplyInfo = _a.supplyInfo, noData = _a.noData, comparisonFetching = _a.comparisonFetching, elecSuppliesCount = _a.elecSuppliesCount;
    var Stack = (0, core_1.useComponents)().Stack;
    var navigate = (0, ui_tools_1.useNavigate)();
    var search = window.location.search;
    var _c = __read((0, react_1.useState)((0, utils_2.getDefaultFuel)(search, supplyInfo)), 2), fuel = _c[0], setFuel = _c[1];
    var _d = __read((0, react_1.useState)((0, utils_2.getDefaultUnit)(search)), 2), unit = _d[0], setUnit = _d[1];
    var supplyStartDate = (0, utils_1.getEarliestSupplyStartDate)(supplyInfo);
    var prevDate = (0, utils_2.getPreviousDateForPeriod)(datePeriod, date, supplyStartDate);
    var nextDate = (0, utils_2.getNextDateForPeriod)(datePeriod, date);
    var prevDisabled = supplyStartDate
        ? !(0, utils_2.isPreviousDateAvailable)(datePeriod, date, supplyStartDate)
        : true;
    var nextDisabled = !(0, utils_2.isNextDateAvailable)(datePeriod, date);
    var isTraditional = !!(0, utils_1.hasTradMeter)(supplyInfo);
    var showReadingPrompt = datePeriod !== 'daily' && compare === 'noComparison' && isTraditional;
    var dailyViewTradMeter = datePeriod === 'daily' && (0, utils_2.isSelectedFuelTrad)(fuel, supplyInfo);
    var missingDataForSelectedUnit = (0, utils_2.isMissingDataForSelectedUnit)(data, fuel, unit);
    var _e = (0, core_1.useCopy)(copy_1.defaultOptions), copy = _e.copy, Copy = _e.Copy;
    var setFuelWithOptimizely = function (fuel) {
        setFuel(fuel);
        navigate({
            search: (0, utils_1.updatedQueryParams)('fuel', fuel, search),
        }, { replace: true });
    };
    var setUnitAndUpdateQueryParams = function (unit) {
        setUnit(unit);
        navigate({
            search: (0, utils_1.updatedQueryParams)('unit', unit, search),
        }, { replace: true });
    };
    (0, react_1.useEffect)(function () {
        if (datePeriod === 'daily') {
            setUnitAndUpdateQueryParams('kwh');
        }
        // We just care about the datePeriod changing.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [datePeriod]);
    return (react_1.default.createElement(ui_tools_1.AnalyticsView, { name: analytics_subjects_1.USAGE_PAGE, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement(Stack, { spaceBetween: [4, 8], "data-testid": "usage-content" },
            react_1.default.createElement(__1.PreviousNextNavigation, { previous: {
                    label: copy('prevNav', {
                        prevDate: (0, utils_2.formatDateForPeriod)(prevDate, datePeriod),
                    }),
                    disabled: prevDisabled,
                    onClick: function () { return setDate(prevDate); },
                }, next: {
                    label: copy('nextNav', {
                        nextDate: (0, utils_2.formatDateForPeriod)(nextDate, datePeriod),
                    }),
                    disabled: nextDisabled,
                    onClick: function () { return setDate(nextDate); },
                } },
                react_1.default.createElement(Copy, { copyKey: "title", values: { date: (0, utils_2.formatDateForPeriod)(date, datePeriod) } })),
            noData ? ((0, utils_1.isCurrentDatePeriod)(date, datePeriod) ? (react_1.default.createElement(__1.NoCurrentDataInfo, { isTraditional: isTraditional, datePeriod: datePeriod })) : (react_1.default.createElement(__1.DataWarning, null))) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(__1.TopStats, { data: data, date: date, datePeriod: datePeriod }),
                react_1.default.createElement(__1.UsageControls, { fuel: fuel, setFuel: setFuelWithOptimizely, fuelOptions: (0, utils_2.getFuelOptions)(supplyInfo), unit: unit, setUnit: setUnitAndUpdateQueryParams, unitOptions: (0, utils_2.getUnitOptions)(datePeriod), compare: compare, setCompare: setCompare, compareOptions: (0, utils_2.getCompareOptions)(datePeriod, date, supplyInfo) }),
                dailyViewTradMeter ? (react_1.default.createElement(__1.DailyViewTradMeterInfo, null)) : missingDataForSelectedUnit ? (react_1.default.createElement(__1.MissingDataForUnitWarning, null)) : (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(Stack, { spaceBetween: [4, 6] },
                        react_1.default.createElement("div", null,
                            elecSuppliesCount > 1 && react_1.default.createElement(__1.DualElecWarning, null),
                            react_1.default.createElement(__1.UsageChart, { data: data, date: date, fuel: fuel, unit: unit, datePeriod: datePeriod, comparisonType: compare, disableLinks: !(0, utils_1.hasSmartMeter)(supplyInfo), setDate: setDate, comparisonDate: comparisonDate, isLoading: comparisonFetching }),
                            react_1.default.createElement(__1.UsageHelpLink, null)),
                        react_1.default.createElement(core_1.FeedbackPrompt, { id: "usage", probability: 25, label: copy('feedbackPrompt') }),
                        react_1.default.createElement("div", null,
                            showReadingPrompt ? (react_1.default.createElement(__1.ReadingPrompt, { fuel: fuel, accountId: accountId, supplyInfo: supplyInfo })) : null,
                            react_1.default.createElement(__1.UsageTable, { data: data, date: date, comparisonDate: comparisonDate, fuel: fuel, unit: unit, datePeriod: datePeriod, comparisonType: compare, disableLinks: !(0, utils_1.hasSmartMeter)(supplyInfo), setDate: setDate, supplyInfo: supplyInfo }))))))))));
};
exports.UsageContent = UsageContent;
